import Text from '../main/Text';
import Day from './Day';
import { IOpeningHour } from '../../interfaces';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

function Schedule({ openingHours }: { openingHours: IOpeningHour[]} ) 
{
    return (
        <div style = {{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
            <Text
                text = 'Working time'
                fontSize = {16}
                fontWeight = {700}
            />

        {
            openingHours?.map(day => 
                <Day 
                    key = {days[day.close.day - 1]}
                    day = {days[day.close.day - 1]}
                    open = {day.open.time}
                    close = {day.close.time} 
                />
            )
        }
        </div>
    )
}

export default Schedule;